const STATUS_CONFIG = {
  'Open':                          { bg: 'bg-slate-100',   text: 'text-slate-600',    dot: 'bg-slate-400',    label: 'Open' },
  'Ticket Assignment':             { bg: 'bg-purple-50',   text: 'text-purple-700',   dot: 'bg-purple-500',   label: 'Ticket Assignment' },
  'Troubleshooting':               { bg: 'bg-amber-50',    text: 'text-amber-700',    dot: 'bg-amber-400 animate-pulse', label: 'Troubleshooting' },
  'RMA':                           { bg: 'bg-red-50',      text: 'text-red-700',      dot: 'bg-red-500',      label: 'RMA' },
  'Replacement':                   { bg: 'bg-pink-50',     text: 'text-pink-700',     dot: 'bg-pink-500',     label: 'Replacement' },
  'Configuration and Installation':{ bg: 'bg-amber-50',    text: 'text-amber-700',    dot: 'bg-amber-400 animate-pulse', label: 'In Progress' },
  'Maintenance':                   { bg: 'bg-amber-50',    text: 'text-amber-700',    dot: 'bg-amber-400 animate-pulse', label: 'Maintenance' },
  'Resolved':                      { bg: 'bg-emerald-50',  text: 'text-emerald-700',  dot: 'bg-emerald-500',  label: 'Resolved' },
  'Closed':                        { bg: 'bg-gray-100',    text: 'text-gray-500',     dot: 'bg-gray-400',     label: 'Closed' },
};

export default function StatusBadge({ status, label: labelOverride }) {
  const cfg = STATUS_CONFIG[status] || { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400', label: status };
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${cfg.bg} ${cfg.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
      {labelOverride || cfg.label}
    </span>
  );
}
